export var getAccountKey = function getAccountKey() {
    return ['account'];
};
